module.exports = __webpack_public_path__ + "img/logo.2a140be9.png";